import TrialPopup from './trial-popup';

export default TrialPopup;
